import { OmniumOrder } from "../Types/Order";

const rootRoute = '/api/order/';

export const loadOmniumOrdersForCustomer = async (pageIndex, pageSize) => {
  const response = await fetch(
    `${rootRoute}?pageIndex=${pageIndex}&showMyOrders=false&pageSize=${pageSize}`
  );
  return await response.json();
}

export const downloadPdf = (order: OmniumOrder) => {
  fetch(
    `${rootRoute}OrderAsPdf?orderId=${order.id}`, {
      headers: {
        'Content-Type': 'application/pdf'
      }
    })
    .then(resp => resp.blob())
    .then(blob => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${order.orderNumber}.pdf`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    })
}